// Shared field types configuration for CustomClientDocument and SettingsTaskModal
export const menuArray = [
  {
    name: "Text",
    label: "Text",
    inputType: "text",
    fontSettings: true,
    settings: true,
    required: true,
    characterLimit: true,
    dimensions: "275x40",
  },
  {
    name: "Input Fields",
    label: "Input Fields",
    child: [
      // {
      //   name: "Text input",
      //   label: "Text input",
      //   inputType: "text",
      //   required: true,
      //   characterLimit: true,
      //   fontSettings: true,
      //   settings: true,
      //   dimensions: "275x40",
      // },
      {
        name: "Text mulit line input",
        label: "Text mulit line input",
        inputType: "textarea",
        required: true,
        characterLimit: true,
        fontSettings: true,
        settings: true,
        dimensions: "275x70",
        fieldLimit: 5,
      },
      {
        name: "Date",
        label: "Date",
        inputType: "date",
        required: true,
        fontSettings: true,
        characterLimit: false,
        settings: true,
        dimensions: "275x40",
        fieldLimit: 5,
      },
    ],
  },
  {
    name: "Selection Fields",
    label: "Selection Fields",
    child: [
      {
        name: "Dropdown",
        label: "Dropdown",
        inputType: "select",
        required: true,
        fontSettings: true,
        settings: true,
        characterLimit: false,
        dimensions: "275x40",
        fieldLimit: 5,
      },
      {
        name: "Checkbox",
        label: "Checkbox",
        inputType: "checkbox",
        required: true,
        fontSettings: false,
        settings: true,
        characterLimit: false,
        dimensions: "63x40",
        fieldLimit: 5,
      },
      {
        name: "Radio",
        label: "Radio",
        inputType: "radio",
        settings: true,
        required: false,
        fontSettings: false,
        characterLimit: false,
        dimensions: "40x40",
        fieldLimit: 5,
      },
    ],
  },
  {
    name: "Initials",
    label: "Initials",
    fontSettings: true,
    required: true,
    settings: true,
    characterLimit: false,
    dimensions: "70x40",
    fieldLimit: 5,
  },
  {
    name: "Signature",
    label: "Signature",
    required: true,
    fontSettings: true,
    characterLimit: false,
    settings: true,
    dimensions: "275x40",
    fieldLimit: 5,
  },
];

// Helper function to get field-specific placeholder text
export const getFieldPlaceholder = (fieldType) => {
  switch (fieldType) {
    case "text":
    case "Text":
      return "Type your text";
    case "Text input":
    case "text-input":
      return "This is a placeholder textbox";
    case "textarea":
    case "Text mulit line input":
    case "text-mulitline":
      return "This is a multiline input field";
    case "Date":
      return "MM-DD-YYYY";
    case "dropdown":
    case "Dropdown":
      return "Select an option";
    case "initials":
    case "Initials":
    case "initial":
      return "N.S";
    default:
      return "Enter text...";
  }
};

// Helper function to get flattened field types for settings modal
export const getAllFieldTypes = () => {
  const allFieldTypes = [];
  
  menuArray.forEach(item => {
    if (item.child) {
      // Add child items
      allFieldTypes.push(...item.child);
    } else {
      // Add parent items that don't have children
      allFieldTypes.push(item);
    }
  });

  return allFieldTypes;
};
